import React, { useState, useEffect } from 'react';
import { withErrorBoundary } from 'shared';
import { useLocation } from 'react-router-dom';

const ARCList = () => {
  const [success, setSuccess] = useState(null);
  const [arcs, setArcs] = useState([]);
  const [message, setMessage] = useState(null);
  const location = useLocation(); // Use the useLocation hook to access the current location
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const divStyle = {
    fontSize: '200px',
    textAlign: 'center',
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const accountNo = new URLSearchParams(location.search).get('accountNo'); // Get the query parameter from the location URL
        const response = await Backend.get('/api/v1/users/vantaca_arc_list', {
          accountNo
        });
        setSuccess(response.success);
        setArcs(response.data);
        setMessage(response.message);
        setError(response.error);
        setLoading(false); // Mark the data loading as completed
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false); // Mark the data loading as completed even if there's an error
      }
    };

    fetchData();
  }, [location]);

  return (
    <div className="CustomMenu container">
      {!loading && (error ? null : (
        <div className="row page-header">
          <div>
            <h5 className="page-title">ARC List Information</h5>
          </div>
        </div>
      ))}
      <div className="row">
        <div className="col">
          {!loading && (!error ? null : ( // Show the logo based on the response and loading state
            <div style={divStyle}>
              <i className="fa fa-exclamation-triangle" size="lg" style={{ color: "#d81326" }}></i>
            </div>
          ))}
          {success !== null && (
            <div>
              {success ? (
                <div>
                  {arcs.length > 0 ? (
                    arcs.map((arc, index) => (
                      <div key={index}>
                        <h6>ARC {index + 1}</h6>
                        <p>ARC Type: {arc.type}</p>
                        <p>ARC Subject: {arc.subject}</p>
                        <p>ARC Description: {arc.description}</p>
                        <p>
                          ARC Status: {arc.closed ? 'Closed' : 'Open'}
                        </p>
                        <p>ARC Date: {arc.created_date}</p>
                        <hr />
                      </div>
                    ))
                  ) : (
                    <p>You have no open ARC List at this time.</p>
                  )}
                </div>
              ) : (
                <p>{message}</p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default withErrorBoundary(ARCList);
